import { render, staticRenderFns } from "./StockMixedShopOrdItems.vue?vue&type=template&id=bddebc26&scoped=true&"
import script from "./StockMixedShopOrdItems.vue?vue&type=script&lang=js&"
export * from "./StockMixedShopOrdItems.vue?vue&type=script&lang=js&"
import style0 from "./StockMixedShopOrdItems.vue?vue&type=style&index=0&id=bddebc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddebc26",
  null
  
)

export default component.exports